function configLanguage (){
    try {
        const language = JSON.parse(localStorage.lang);    

        return language.lang
    } catch (error) {
        const idiomaSelecionado = {
            lang: 'pt'
        }
        
        localStorage.lang = JSON.stringify(idiomaSelecionado)
    }

}

export default configLanguage